import React, { useState } from 'react';

import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core';
import { InfoOutlined, CloseOutlined } from '@material-ui/icons';

import { convertToHumanReadableTitle } from 'services/helpers/formatters';

const useStyles = makeStyles((theme) => ({
  infoButton: {
    color: theme.palette.secondary.contrastText,
    marginLeft: theme.spacing(1.5),
  },

  content: {
    padding: theme.spacing(2, 2, 3),
    width: theme.spacing(50),
    maxHeight: theme.spacing(40),
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },

  title: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: 12,
  },

  closeButton: {
    color: theme.palette.secondary.contrastText,
    marginRight: theme.spacing(-1),
  },

  infoBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
}));

const ShipmentInfoField = (props) => {
  const { shipmentInfo } = props.record;
  const [anchorEl, setAnchorEl] = useState(null);

  const classes = useStyles();

  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    event.stopPropagation();
  };

  return (
    <>
      <IconButton className={classes.infoButton} size="small" onClick={handleOpen}>
        <InfoOutlined />
      </IconButton>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        onClick={handleClick}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <Box className={classes.content}>
          <Box className={classes.header}>
            <Box className={classes.title}>Shipment info</Box>
            <IconButton className={classes.closeButton} size="small" onClick={handleClose}>
              <CloseOutlined />
            </IconButton>
          </Box>

          {!!shipmentInfo &&
            Object.entries(shipmentInfo)
              .filter(([_key, value]) => Boolean(value))
              .map(([key, value]) => (
                <Box className={classes.infoBox}>
                  <Box>{convertToHumanReadableTitle(key)}</Box>
                  <Box>{value}</Box>
                </Box>
              ))}
        </Box>
      </Popover>
    </>
  );
};

export default ShipmentInfoField;
